import React from "react";
import RoadCarrierListItem from "../../components/roadCarrier/RoadCarrierList/RoadCarrierListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const RoadCarrierListPage = ()  => {

    useTitle(t`List Road Carrier`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <RoadCarrierListItem showAdd={true} {...query} />
        </Box>
    )
}

export default RoadCarrierListPage;
